<template lang="pug">
  .simple.search-page.mt-8
    slot(name="header")
    main(v-if="areas.main && areas.main.length")
      section(
        v-for="(section, index) in areas.main"
        :key="section.id"
        :class="section.key"
      )
        SearchInput(v-if="section.key === 'search-input'" :section="section")
        ProductSearchResults(
            v-if="section.key === 'product-search-results'"
            :section="section"
            forced-orientation="horizontal"
        )
    slot(name="footer")
</template>

<script>
import Page from '@/views/Page';
import SearchInput from '@/components/SearchInput';
import ProductSearchResults from '@/extensions/shop/components/SearchResults';

export default {
    name: 'Search',
    extends: Page,
    components: {
        SearchInput,
        ProductSearchResults
    }
};
</script>

<style lang="sass" scoped>

.simple.search-page,
.simple.search-page main
  @apply flex mb-8
  flex-direction: column
</style>
